var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 5.6665L6.62785 6.82612C7.77132 7.50219 8.22836 7.50219 9.37183 6.82612L11.3332 5.6665",
    stroke: "#171718",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34401 8.98391C1.38759 11.0276 1.40938 12.0494 2.16347 12.8064C2.91755 13.5634 3.96705 13.5897 6.06605 13.6425C7.3597 13.675 8.64063 13.675 9.93428 13.6425C12.0333 13.5897 13.0828 13.5634 13.8369 12.8064C14.5909 12.0494 14.6127 11.0276 14.6563 8.98391C14.6703 8.32679 14.6703 7.67355 14.6563 7.01643C14.6127 4.97274 14.5909 3.95089 13.8369 3.19394C13.0828 2.43698 12.0333 2.41061 9.93428 2.35788C8.64063 2.32537 7.3597 2.32537 6.06604 2.35787C3.96705 2.41061 2.91755 2.43697 2.16346 3.19393C1.40938 3.95088 1.38759 4.97273 1.34401 7.01642C1.32999 7.67354 1.32999 8.32679 1.34401 8.98391Z",
    stroke: "#171718",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.eb9e1c822569e480ebb38dff39f0f3c6.svg";
export { ForwardRef as ReactComponent };